import React from 'react';
import SignUpsLayout from './components/SignUpsLayout';
import PerformanceCardSkeleton from '../../components/PerformanceCardSkeleton';
import EntityCardSkeleton from '../../components/EntityCardSkeleton';

const TabSkeleton = () => (
  <>
    <PerformanceCardSkeleton />
    <div style={{ marginTop: 10 }}>
      <EntityCardSkeleton />
    </div>
  </>
);

const SignUpsTab = ({
  colStyle,
  selectedCampaign,
  chartsLoading,
  campaignOrder,
  chartData,
  bySignUpRangeDate,
  setSignUpRangeDate,
  dataSignUpRangeDate,
  setDataSignUpRangeDate,
  setbySignUpsAttributionWindow,
  setdataSignUpsDate,
  bySignUpsAttributionWindow,
  dataSignUpsDate,
  reportName,
  signupsTable,
  signupsTableLoading,
  attributionWindow,
  setCurrentIdx,
  setCurrentStartEndDate,
  setAttributionWindow,
}) => {
  if (chartsLoading) return <TabSkeleton />;

  return (
    <SignUpsLayout
      colStyle={colStyle}
      selectedCampaign={selectedCampaign}
      campaignOrder={campaignOrder}
      chartData={chartData}
      bySignUpRangeDate={bySignUpRangeDate}
      setSignUpRangeDate={setSignUpRangeDate}
      dataSignUpRangeDate={dataSignUpRangeDate}
      setDataSignUpRangeDate={setDataSignUpRangeDate}
      setbySignUpsAttributionWindow={setbySignUpsAttributionWindow}
      setdataSignUpsDate={setdataSignUpsDate}
      bySignUpsAttributionWindow={bySignUpsAttributionWindow}
      dataSignUpsDate={dataSignUpsDate}
      reportName={reportName}
      signupsTable={signupsTable}
      signupsTableLoading={signupsTableLoading}
      setCurrentIdx={setCurrentIdx}
      setCurrentStartEndDate={setCurrentStartEndDate}
      attributionWindow={attributionWindow}
      setAttributionWindow={setAttributionWindow}
    />
  );
};

export default SignUpsTab;
